import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
const Scroll2Top = () => {
  const { pathname } = useLocation();
  // let hash = window.location.hash;
  // console.log("pathname, hash", pathname, hash);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default Scroll2Top;
